import error from "./error.json";
import event from "./event.json";
import friends from "./friends.json";
import group from "./group.json";
import maintenance from "./maintenance.json";
import offline from "./offline.json";
import update from "./update.json";

const lottiePlaceholders = {
  error,
  event,
  friends,
  group,
  maintenance,
  offline,
  update,
};

export default lottiePlaceholders;
